<h2 mat-dialog-title>{{ isEdit ? 'Edit' : 'Add' }} Certificate User Binding</h2>

<mat-dialog-content [formGroup]="form">
    <!-- In edit mode, certificate field is read-only -->
    <ng-container *ngIf="isEdit; else certFieldSelect">
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Certificate Field</mat-label>
            <input matInput [value]="data.binding?.x509CertificateField" readonly />
        </mat-form-field>
    </ng-container>
    <ng-template #certFieldSelect>
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Certificate Field</mat-label>
            <mat-select formControlName="x509CertificateField">
                <mat-optgroup label="Low Affinity">
                    <mat-option value="RFC822Name" [disabled]="isCertFieldDisabled('RFC822Name') ">RFC822Name</mat-option>
                    <mat-option value="PrincipalName" [disabled]="isCertFieldDisabled('PrincipalName') ">PrincipalName</mat-option>
                    <mat-option value="IssuerAndSubject" [disabled]="isCertFieldDisabled('IssuerAndSubject') ">IssuerAndSubject</mat-option>
                    <mat-option value="Subject" [disabled]="isCertFieldDisabled('Subject') ">Subject</mat-option>
                </mat-optgroup>
                <mat-optgroup label="High Affinity">
                    <mat-option value="IssuerAndSerialNumber" [disabled]="isCertFieldDisabled('IssuerAndSerialNumber')">IssuerAndSerialNumber</mat-option>
                    <mat-option value="SubjectKeyIdentifier" [disabled]="isCertFieldDisabled('SubjectKeyIdentifier')">SubjectKeyIdentifier</mat-option>
                    <mat-option value="SHA1PublicKey" [disabled]="isCertFieldDisabled('SHA1PublicKey')">SHA1PublicKey</mat-option>
                </mat-optgroup>
            </mat-select>

        </mat-form-field>
    </ng-template>

    <mat-form-field appearance="fill" class="w-full">
        <mat-label>User Property</mat-label>
        <mat-select formControlName="userProperty">
            <mat-option *ngFor="let prop of userPropertyOptions" [value]="prop">
                {{ prop }}
            </mat-option>
        </mat-select>
    </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="form?.invalid" (click)="onSave()">
        {{ isEdit ? 'Save' : 'Add' }}
    </button>
</mat-dialog-actions>
